import React, { useEffect, useRef, useState } from 'react';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { useSnackbar } from 'notistack';
import { Button, Form } from 'react-bootstrap';

const ABOUT_US_ID = 1;

const parseJSON = async (response) => {
    try {
        if (response.status === 204 || response.status === 205) return null;
        const text = await response.text();
        if (!text) return null;
        return JSON.parse(text);
    }
    catch (err) {
        console.warn('Failed to parse JSON response', err);
        return null;
    }
}

function AddAboutUs() {
    const token = JSON.parse(localStorage.getItem('tcn'));
    const userId = JSON.parse(localStorage.getItem('userid')) || 0;
    const authToken = typeof token === 'string' ? token : token?.token || token?.Token || '';

    const { enqueueSnackbar } = useSnackbar();

    const [aboutUsId, setAboutUsId] = useState(ABOUT_US_ID);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [ownerName, setOwnerName] = useState('');
    const [designation, setDesignation] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [image1File, setImage1File] = useState(null);
    const [image2File, setImage2File] = useState(null);
    const [image1Preview, setImage1Preview] = useState('');
    const [image2Preview, setImage2Preview] = useState('');
    const [loading, setLoading] = useState(false);

    const titleRef = useRef(null);
    const ownerNameRef = useRef(null);
    const designationRef = useRef(null);
    const descriptionRef = useRef(null);
    const image1Ref = useRef(null);
    const image2Ref = useRef(null);

    useEffect(() => {
        const fetchRecord = async () => {
            try {
                const response = await fetch(APIUrl.AboutUs + 'GetAboutUsById_web/' + ABOUT_US_ID, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`
                    },
                    body: JSON.stringify()
                });

                const result = await parseJSON(response);
                const record = result?.data || null;
                if (record) {
                    setAboutUsId(record.AboutUsId || ABOUT_US_ID);
                    setTitle(record.Title || '');
                    setDescription(record.Description || '');
                    setOwnerName(record.OwnerName || '');
                    setDesignation(record.Designation || '');
                    setIsActive(record.IsActive ?? true);
                    setImage1Preview(record.ImagePath1 ? `${APIUrl.BaseUrl}/${record.ImagePath1}` : '');
                    setImage2Preview(record.ImagePath2 ? `${APIUrl.BaseUrl}/${record.ImagePath2}` : '');
                }
            }
            catch (error) {
                console.log(error);
            }
        };

        fetchRecord();
    }, [authToken]);

    const handleFileChange = (e, index) => {
        const file = e.target.files?.[0] || null;
        if (index === 1) {
            setImage1File(file);
            setImage1Preview(file ? URL.createObjectURL(file) : '');
        } else {
            setImage2File(file);
            setImage2Preview(file ? URL.createObjectURL(file) : '');
        }
    };

    const validateForm = () => {
        if (!ownerName || !ownerName.trim()) {
            enqueueSnackbar('Owner Name is required.', { variant: 'warning' });
            ownerNameRef.current?.focus();
            return false;
        }

        if (!designation || !designation.trim()) {
            enqueueSnackbar('Designation is required.', { variant: 'warning' });
            designationRef.current?.focus();
            return false;
        }

        if (!title || !title.trim()) {
            enqueueSnackbar('Title is required.', { variant: 'warning' });
            titleRef.current?.focus();
            return false;
        }

        if (!description || !description.trim()) {
            enqueueSnackbar('Description is required.', { variant: 'warning' });
            descriptionRef.current?.focus();
            return false;
        }

        if (!image1Preview && !image1File) {
            enqueueSnackbar('Image 1 is required.', { variant: 'warning' });
            image1Ref.current?.focus();
            return false;
        }

        if (!image2Preview && !image2File) {
            enqueueSnackbar('Image 2 is required.', { variant: 'warning' });
            image2Ref.current?.focus();
            return false;
        }

        return true;
    };

    const submitForm = async () => {
        if (!authToken) {
            enqueueSnackbar('Please login first.', { variant: 'warning' });
            return;
        }

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('AboutUsId', String(aboutUsId));
            formData.append('Title', title || '');
            formData.append('Description', description || '');
            formData.append('OwnerName', ownerName || '');
            formData.append('Designation', designation || '');
            formData.append('IsActive', String(Boolean(isActive)));
            formData.append('ModifyBy', String(userId || 0));

            if (image1File) formData.append('ImagePath1', image1File, image1File.name);
            if (image2File) formData.append('ImagePath2', image2File, image2File.name);

            const response = await fetch(APIUrl.AboutUs + 'UpdateAboutUs', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`
                },
                body: formData
            });

            const result = await parseJSON(response);
            if (result?.Message === 'Success' || response.status === 201 || result?.returnID !== undefined) {
                enqueueSnackbar('About Us updated successfully.', { variant: 'success' });
                // reload
                window.location.reload();
                return;
            }

            enqueueSnackbar(result?.Message || 'Failed to update About Us.', { variant: 'error' });
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar('Error while updating About Us.', { variant: 'error' });
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Layout>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                    <div className="space-y-6">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                            <h2 className="text-xl font-semibold text-gray-900 mb-6">About Us (Upsert for ID 1)</h2>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">


                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Owner Name</label>
                                    <input ref={ownerNameRef} value={ownerName} onChange={(e) => setOwnerName(e.target.value)} type="text" className="w-full px-4 py-3 border border-gray-300 rounded-lg" />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Designation</label>
                                    <input ref={designationRef} value={designation} onChange={(e) => setDesignation(e.target.value)} type="text" className="w-full px-4 py-3 border border-gray-300 rounded-lg" />
                                </div>


                                <div className="md:col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Title</label>
                                    <input ref={titleRef} value={title} onChange={(e) => setTitle(e.target.value)} type="text" className="w-full px-4 py-3 border border-gray-300 rounded-lg" />
                                </div>
                                <div className="md:col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                                    <textarea
                                        ref={descriptionRef}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        rows={6}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                                        placeholder="Enter description"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Image 1</label>
                                    <input ref={image1Ref} type="file" accept="image/*" onChange={(e) => handleFileChange(e, 1)} />
                                    {image1Preview && <img src={image1Preview} alt="preview1" className="mt-2 w-40 h-24 object-cover" />}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Image 2</label>
                                    <input ref={image2Ref} type="file" accept="image/*" onChange={(e) => handleFileChange(e, 2)} />
                                    {image2Preview && <img src={image2Preview} alt="preview2" className="mt-2 w-40 h-24 object-cover" />}
                                </div>
                            </div>

                            <div className="flex gap-4 mt-4">
                                <Button
                                    onClick={() => submitForm()}
                                    disabled={loading}
                                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg shadow-sm transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
                                >
                                    {loading ? 'Saving...' : 'Update'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </main>
            </Layout>
        </div>
    );
}

export default AddAboutUs;
